<script lang="ts">
  export let svgStyles: string = ''
  export let fillStyles: string = ''
</script>

<svg width="16" height="16" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <path
    d="M25.6806 1.07003L24.6106 4.30305e-06C15.3022 3.42509 10.1816 4.18537 1.28403 2.56806L1.28403 6.20615C10.4429 6.42516 15.2102 5.81301 22.6846 2.56807C13.2525 10.4844 8.31991 15.1446 -4.15338e-06 23.7546L1.92604 25.6806C10.79 16.9642 15.4824 11.9993 23.3266 2.99608C19.8799 10.2161 19.6293 14.9086 19.4745 24.3966L22.8986 24.3966C21.666 15.2387 22.3807 10.1335 25.6806 1.07003Z"
    fill={fillStyles}
  />
</svg>
